export const getVehicleYearFromDescription = (description: string | undefined | null): string | undefined => {
  if (!description) {
    return undefined;
  }

  return description.split(' ')[0];
};
